import styled from 'styled-components'
import { font, bp } from 'lib/core/resources/helpers/styled'
import { FlexWrapper } from 'lib/ui/components'
import { container, heading1, link } from 'app/sofia/resources/theme/css'
import { heading2 as heading2Livbrite, container as containerLivbrite } from 'app/livbrite/resources/theme/css'

export const ContainerPrimary = styled.div<any>`
  ${props => props.isSofia ? container : containerLivbrite}
  margin-top: 35px;

  .breadrumbs {
    margin-bottom: 20px;
  }

  > div:not(.breadrumbs) {
    display: flex;
    align-items: flex-start;
    ${bp('lg')`
      flex-wrap: wrap;
    `}

    > div {
      width: 60%;
      box-sizing: border-box;
      ${bp('lg')`
        width: 100%;
      `}

      &:first-of-type {
        padding-right: 3%;
      }
    }
  }

  h1 {
    ${props => props.isSofia ? heading1 : heading2Livbrite}
    color: ${props => props.isSofia ? props => props.theme.palette.general.strong : props => props.theme.palette.primary.alphaDark};
    margin: 0;
    ${bp('sm')`
      margin-bottom: 10px;
    `}
  }

  .product {
    &__information {
      width: 70% !important;
      margin-left: 18px;
      max-width: 600px;
      ${bp('lg')`
        width: 100% !important;
        max-width: unset;
        margin-left: 0;
      `}

      > div:not(.promo-tag) {
        border: 1px solid ${props => props.theme.palette.general.greyLight};
        padding: 24px;
        border-radius: 4px;
      }

      .promo-tag {
        background: ${props => props.theme.palette.primary.gamma};
        color: ${props => props.theme.palette.general.light};
        padding: 10px;
        text-align: center;

        & + div {
          border-radius: 0 0 4px 4px;
        }
      }
    }

    &__status {
      font: ${props => props.isSofia ? font('default', 'normal', '14px/1') : font('default', 'normal', '16px/22px')};
      color: ${props => props.isSofia ? props => props.theme.palette.primary.betaLight : props => props.theme.palette.primary.alphaDark};
      margin: 5px 0 10px;
    }

    &__short-desc {
      font: ${props => props.isSofia ? font('default', 'normal', '14px/1.4') : font('default', 'medium', '16px/1.2')};
      color: ${props => props.isSofia ? props => props.theme.palette.general.strong : props => props.theme.palette.primary.alphaDark};
    }
  }
`

export const ContainerBottom = styled.div<any>`
  ${props => props.isSofia ? container : containerLivbrite}
  margin: 20px auto 60px;

  h2 {
    text-align: center;
    font: ${font('alt', 'normal', '24px/1.5')};
    color: ${props => props.theme.palette.general.strong};
  }
`

export const ProductImageWrapper = styled(FlexWrapper)<any>`
  position: relative;
  justify-content: center;
  align-items: center;
  padding: 0 5%;
  box-sizing: border-box;
  ${bp('sm')`
    margin-bottom: 10px;
  `}
`

export const WishListWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  > p {
    margin: 0;
    color: ${props => props.theme.palette.primary.alphaDark};
    font-size: 18px;
  }
`

export const RatingWrapper = styled(FlexWrapper)`
  align-items: center;
  font-size: 18px;
  line-height: 1;

  > span {
    ${link};
    cursor: pointer;
    margin-left: 10px;

    &.new {
      border-left: 1px solid ${props => props.theme.palette.general.borderColor};
      padding-left: 10px;
    }
  }
`

export const RatingBrand = styled(FlexWrapper)`
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  > a {
    ${link}
    font: ${font('default', 'bold', '14px/1')};
    text-decoration: none;
  }
`
